import { Box, Button, Link, Modal } from "@mui/material";
import React from "react";
import { useState } from "react";
import styles from "./style.module.css";
import { AiOutlineClose } from "react-icons/ai";
import { GiHamburgerMenu } from "react-icons/gi";
import { useSelector } from "react-redux";
import { NavLink } from "react-router-dom";

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  display: "grid",
  placeItems: "center",
  justifyContent: "center",
  gap: "10px",
  width: "95vw",
  height: "95vh",
  bgcolor: "background.paper",
  border: "2px solid #000",
  borderRadius: "10px",
  boxShadow: 24,
  p: 4,
};

export const MobileMenu = () => {
  const token = useSelector((state) => state.user.token);
  const [isLogged] = useState(false);

  const [modalOpen, setModalOpen] = useState(false);
  const handleModalOpen = () => setModalOpen(true);
  const handleModalClose = () => setModalOpen(false);

  return (
    <div className="relative">
      <Button
        onClick={handleModalOpen}
        aria-expanded={modalOpen}
        className="shadow-md"
      >
        <GiHamburgerMenu size={28} color="#f6655f" />
      </Button>
      <Modal
        open={modalOpen}
        onClose={handleModalClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={style}>
          <div className={`${styles.closeIcon} absolute top-5 right-5`}>
            <button
              className={`${styles.button}  hover:animate-pulse`}
              onClick={handleModalClose}
            >
              <AiOutlineClose size={34} color="black" />
            </button>
          </div>
          <nav className={styles.navLink}>
            {!token ? (
              <>
                <NavLink
                  to="/"
                  className={({ isActive }) =>
                    isActive
                      ? "text-red-500 font-bold text-3xl py-3 px-6"
                      : "text-[#f6655f] hover:text-red-600 hover:underline text-base "
                  }
                  onClick={() => setModalOpen(!modalOpen)}
                >
                  {" "}
                  Home
                </NavLink>
                <NavLink
                  to="/about-us"
                  className={({ isActive }) =>
                    isActive
                      ? "text-red-500 font-bold text-3xl py-3 px-6"
                      : "text-[#f6655f] hover:text-red-600 hover:underline text-base "
                  }
                  onClick={() => setModalOpen(!modalOpen)}
                >
                  {" "}
                  About
                </NavLink>

                <NavLink
                  to="/contact-us"
                  className={({ isActive }) =>
                    isActive
                      ? "text-red-500 font-bold text-3xl py-3 px-6"
                      : "text-[#f6655f]  hover:text-red-600 hover:underline text-base "
                  }
                  onClick={() => setModalOpen(!modalOpen)}
                >
                  {" "}
                  Contact
                </NavLink>

                <NavLink
                  to="/need-blood"
                  className={({ isActive }) =>
                    isActive
                      ? "text-red-500 uppercase font-bold outline outline-1 outline-[#f6655f] py-[14px] px-5 text-base rounded-full bg-[#f7c9c7]"
                      : "text-[#f6655f]  hover:text-red-500 py-[14px] px-5 rounded-full text-base hover:font-bold  cursor-pointer outline outline-2 outline-[#f6655f] hover:bg-[#f7c9c7]"
                  }
                  onClick={() => setModalOpen(!modalOpen)}
                >
                  {" "}
                  Need Blood
                </NavLink>
              </>
            ) : (
              <>
                <NavLink
                  to="/"
                  className={({ isActive }) =>
                    isActive
                      ? "text-red-500 font-bold text-3xl py-3 px-6"
                      : "text-[#f6655f] hover:text-red-600 hover:underline text-base "
                  }
                  onClick={() => setModalOpen(!modalOpen)}
                >
                  {" "}
                  Home
                </NavLink>
                <NavLink
                  to="/about-us"
                  className={({ isActive }) =>
                    isActive
                      ? "text-red-500 font-bold text-3xl py-3 px-6"
                      : "text-[#f6655f] mx- cursor-pointer hover:text-red-600 hover:underline text-base "
                  }
                  onClick={() => setModalOpen(!modalOpen)}
                >
                  {" "}
                  About
                </NavLink>

                <NavLink
                  to="/contact-us"
                  className={({ isActive }) =>
                    isActive
                      ? "text-red-500 font-bold text-3xl py-3 px-6"
                      : "text-[#f6655f] mx-1 cursor-pointer hover:text-red-600 hover:underline text-base "
                  }
                  onClick={() => setModalOpen(!modalOpen)}
                >
                  {" "}
                  Contact
                </NavLink>

                <NavLink
                  to="/dashboard"
                  className={({ isActive }) =>
                    isActive
                      ? "text-red-500 uppercase font-bold outline outline-1 outline-[#f6655f] py-[14px] px-5 rounded-full bg-[#f7c9c7]"
                      : "text-[#f6655f]  hover:text-red-500 py-[14px] px-5 rounded-full text-base hover:font-bold uppercase cursor-pointer outline outline-2 outline-[#f6655f] hover:bg-[#f7c9c7]"
                  }
                  onClick={() => setModalOpen(!modalOpen)}
                  aria-label="Will lead to user account bio if user is logged in"
                >
                  {" "}
                  Account
                </NavLink>
              </>
            )}
            {!token ? (
              <>
                {isLogged ? (
                  <Link
                    href="/dashboard"
                    aria-label="Link to sign up modal if user is not signed in yet"
                    onClick={handleModalClose}
                  >
                    {/* donate blood */}
                  </Link>
                ) : (
                  <NavLink
                    to="/auth"
                    className={({ isActive }) =>
                      isActive
                        ? "text-red-500 uppercase font-bold outline outline-2 outline-[#f6655f] py-[14px] px-5 rounded-full bg-[#f7c9c7]"
                        : "bg-[#f6655f] text-white  hover:bg-red-600 py-[14px] px-5 rounded-full text-base hover:font-bold uppercase cursor-pointer outline outline-2 outline-[#f6655f] "
                    }
                    onClick={() => setModalOpen(!modalOpen)}
                    aria-label="Will lead to user account bio if user is logged in"
                  >
                    {" "}
                    Donate Blood
                  </NavLink>
                )}
              </>
            ) : null}
          </nav>
        </Box>
      </Modal>
    </div>
  );
};
